import addressChecker from '../locales/components/address-checker.json'
import blogCarousel from '../locales/components/blog-carousel.json'
import businessFiberCTA from '../locales/components/business-fiber-cta.json'
import customerTestimonials from '../locales/components/customer-testimonials.json'
import errorMessages from '../locales/components/error-messages.json'
import faqs from '../locales/components/faqs.json'
import fcc from '../locales/components/fcc.json'
import navigation from '../locales/components/navigation.json'
import twoFactorAuthentication from '../locales/components/two-factor-authentication.json'
import about from '../locales/pages/about.json'
import eightOneOne from '../locales/pages/811.json'
import acceptableUsePolicy from '../locales/pages/acceptable-use-policy.json'
import alreadyRegistered from '../locales/pages/already-registered.json'
import blogPage from '../locales/pages/blog.json'
import business from '../locales/pages/business.json'
import careers from '../locales/pages/careers.json'
import findAddress from '../locales/pages/find-address.json'
import forgotPasswordHashPage from '../locales/pages/forgot-password-hash.json'
import forgotPasswordPage from '../locales/pages/forgot-password.json'
import getFiber from '../locales/pages/get-fiber.json'
import helpCenter from '../locales/pages/help-center.json'
import home from '../locales/pages/home.json'
import installation from '../locales/pages/installation.json'
import latePayments from '../locales/pages/late-payments.json'
import login from '../locales/pages/login.json'
import pressPage from '../locales/pages/press.json'
import privacy from '../locales/pages/privacy.json'
import residentialInternet from '../locales/pages/residential-internet.json'
import serviceArea from '../locales/pages/service-area.json'
import tos from '../locales/pages/tos.json'
import unactivatedUser from '../locales/pages/unactivated-user.json'

const components = [
	login,
	twoFactorAuthentication,
	forgotPasswordPage,
	forgotPasswordHashPage,
	errorMessages,
	addressChecker,
	businessFiberCTA,
	findAddress,
	getFiber,
	alreadyRegistered,
	acceptableUsePolicy,
	latePayments,
	unactivatedUser,
	fcc,
	pressPage,
	blogPage,
	helpCenter,
	home,
	installation,
	privacy,
	tos,
	residentialInternet,
	customerTestimonials,
	faqs,
	blogCarousel,
	business,
	navigation,
	careers,
	serviceArea,
	about,
	eightOneOne
]
const en = Object.assign({
},
...components.map(({ en }) => en))
const es = Object.assign({
},
...components.map(({ es }) => es))

export default defineI18nConfig(() => ({
	legacy: false,
	globalInjection: true,
	missingWarn: false,
	warnHtmlMessage: false,
	messages: {
		en,
		es
	}
}))
